module.exports = __webpack_public_path__ + "media/images/product_lines/travel/h2-17cb3fa3d8d958c285ec5835bacf30ae.svg";